import JSPath from 'jspath';

import { commonUtils } from '../../common/index.js';

import { IMoveTransformOptions } from './models/TMoveTransform.js';
import { MigrationTransformBase } from './MigrationTransformBase.js';

export class MoveTransform extends MigrationTransformBase<IMoveTransformOptions> {
	get type(): string {
		return 'move';
	}
	up(seed: object): object {
		const { oldKey, oldParentJsPath, newKey, newParentJsPath } = this.options;
		return this.move(seed, oldKey, newKey, oldParentJsPath, newParentJsPath);
	}
	down(seed: object): object {
		const { oldKey, oldParentJsPath, newKey, newParentJsPath } = this.options;
		return this.move(seed, newKey, oldKey, newParentJsPath, oldParentJsPath);
	}
	move(seed: object, oldKey: string, newKey: string, oldParentJsPath?: string, newParentJsPath?: string) {
		const clone = commonUtils.deepMergeObjects({}, seed);
		const oldParents = oldParentJsPath ? JSPath.apply(oldParentJsPath, clone) : [clone];
		for (const oldParent of oldParents) {
			const oldValue = oldParent[oldKey];
			const newParents = newParentJsPath ? JSPath.apply(newParentJsPath, clone) : [clone];
			for (const newParent of newParents) {
				if (newParentJsPath === oldParentJsPath) {
					if (newParent === oldParent) {
						newParent[newKey] = oldValue;
						delete oldParent[oldKey];
					}
				} else {
					newParent[newKey] = oldValue;
					delete oldParent[oldKey];
				}
			}
		}
		return clone;
	}
}
